import { setIsHsCompaniesExportEnabled, setIsHsContactsExportEnabled } from "./hubspotActions";
import {
    setIsSfAccountsExportEnabled,
    setIsSfContactsExportEnabled,
    setIsSfLeadsExportEnabled,
} from "./salesforceActions";
import {
    setIsDynamicsAccountsExportEnabled,
    setIsDynamicsContactsExportEnabled,
    setIsDynamicsLeadsExportEnabled,
} from "./dynamicsActions";

export const setIsExportRecordEnabledConfig = {
    salesforce: {
        accounts: setIsSfAccountsExportEnabled,
        contacts: setIsSfContactsExportEnabled,
        leads: setIsSfLeadsExportEnabled,
        companyAsLeads: setIsSfLeadsExportEnabled,
    },
    hubspot: {
        accounts: setIsHsCompaniesExportEnabled,
        contacts: setIsHsContactsExportEnabled,
    },
    dynamics: {
        accounts: setIsDynamicsAccountsExportEnabled,
        contacts: setIsDynamicsContactsExportEnabled,
        leads: setIsDynamicsLeadsExportEnabled,
        companyAsLeads: setIsDynamicsLeadsExportEnabled,
    },
};
